import React from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { TID } from "../constants/testIds";
import { Button } from "./ui/button";
import Logo from "./Logo";
import { LogOut, Menu, X } from "lucide-react";
import { useState } from "react";

export default function Navbar() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  const linkClass = ({ isActive }) =>
    `px-3 py-2 text-sm font-medium tracking-tight transition-colors ${
      isActive ? "text-[#10B981]" : "text-slate-300 hover:text-white"
    }`;

  return (
    <header className="sticky top-0 z-50 border-b border-[#334155] bg-[#0F172A]/85 backdrop-blur-xl">
      <div className="mx-auto flex h-16 max-w-[1600px] items-center justify-between px-6">
        <NavLink to="/" className="flex items-center gap-2">
          <Logo size={32} textClass="text-lg" tone="light" />
          <span className="ml-2 rounded-full border border-[#334155] px-2 py-0.5 text-[10px] uppercase tracking-[0.2em] text-slate-400">Bangalore</span>
        </NavLink>

        <nav className="hidden md:flex items-center gap-1">
          <NavLink to="/map" className={linkClass} data-testid={TID.navMap}>Map</NavLink>
          <NavLink to="/properties" className={linkClass} data-testid="nav-properties">Properties</NavLink>
          <NavLink to="/projects" className={linkClass} data-testid={TID.navProjects}>Projects</NavLink>
          <NavLink to="/calculator" className={linkClass} data-testid={TID.navCalc}>FAR Calc</NavLink>
          <NavLink to="/compare" className={linkClass} data-testid={TID.navCompare}>Compare</NavLink>
          {user && <NavLink to="/bookings" className={linkClass} data-testid={TID.navBookings}>Bookings</NavLink>}
          {user?.role === "admin" && <NavLink to="/admin" className={linkClass} data-testid={TID.navAdmin}>Admin</NavLink>}
        </nav>

        <div className="hidden md:flex items-center gap-2">
          {user ? (
            <>
              <span className="text-xs text-slate-400 mr-2">{user.email} · <span className="text-[#10B981] uppercase">{user.role}</span></span>
              <Button data-testid={TID.navLogout} variant="ghost" size="sm" onClick={async () => { await logout(); navigate("/"); }}>
                <LogOut className="h-4 w-4 mr-2" /> Logout
              </Button>
            </>
          ) : (
            <>
              <Button data-testid={TID.navLogin} variant="ghost" size="sm" onClick={() => navigate("/login")}>Log in</Button>
              <Button data-testid={TID.navSignup} size="sm" className="bg-[#10B981] hover:bg-[#059669] rounded-full text-white" onClick={() => navigate("/signup")}>Get Access</Button>
            </>
          )}
        </div>

        <button className="md:hidden text-white" onClick={() => setOpen((v) => !v)} aria-label="menu">
          {open ? <X /> : <Menu />}
        </button>
      </div>
      {open && (
        <div className="md:hidden border-t border-[#334155] bg-[#0F172A] px-6 py-3 flex flex-col gap-2">
          <NavLink to="/map" onClick={() => setOpen(false)} className={linkClass}>Map</NavLink>
          <NavLink to="/properties" onClick={() => setOpen(false)} className={linkClass}>Properties</NavLink>
          <NavLink to="/projects" onClick={() => setOpen(false)} className={linkClass}>Projects</NavLink>
          <NavLink to="/calculator" onClick={() => setOpen(false)} className={linkClass}>FAR Calc</NavLink>
          <NavLink to="/compare" onClick={() => setOpen(false)} className={linkClass}>Compare</NavLink>
          {user && <NavLink to="/bookings" onClick={() => setOpen(false)} className={linkClass}>Bookings</NavLink>}
          {user?.role === "admin" && <NavLink to="/admin" onClick={() => setOpen(false)} className={linkClass}>Admin</NavLink>}
          {!user && <NavLink to="/login" onClick={() => setOpen(false)} className={linkClass}>Log in</NavLink>}
          {!user && <NavLink to="/signup" onClick={() => setOpen(false)} className={linkClass}>Sign up</NavLink>}
          {user && <button onClick={async () => { await logout(); setOpen(false); navigate("/"); }} className="text-left text-slate-300">Logout</button>}
        </div>
      )}
    </header>
  );
}
